export const getResolvedHostname = (resolvedRegion, {
  regionHostname,
  partitionHostname
}) => regionHostname ? regionHostname : partitionHostname ? partitionHostname.replace("{region}", resolvedRegion) : undefined;